import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './AccommodationTeaserSkeleton.css';

const AccommodationTeaserSkeleton = () => {
    return (
        <article className="teaser-accommodation">
            <div className="teaser-accommodation--inner">
                <div className="teaser-accommodation--image">
                    <div className="teaser-accommodation--icons">
                        <Skeleton containerClassName="trustyou-rating" baseColor="#fff" width={100} height={50} />
                        <Skeleton containerClassName="teaser--watchlist" circle={true} width={50} height={50} baseColor="#fff" />
                    </div>
                    <Skeleton />
                </div>
                <div className="teaser-accommodation--content">
                    <div className="teaser-accommodation--type">
                        <Skeleton className="type-pill" inline={true} width={100} borderRadius={10} style={{border: 0}}/>
                        <Skeleton className="type-pill" inline={true} width={100} borderRadius={10} style={{border: 0}} />
                    </div>
                    {/*
                    <header>
                        <h2 className="teaser-accommodation--headline"><Skeleton /></h2>
                        <small><Skeleton /></small>
                    </header>*/}
                    {/*<div className="teaser-accommodation--price">
                        <p className="price h5" data-tooltip="Lorem Ipsum Dolor Sit Ammet"><span><Skeleton /></span></p>
                        <p className="price-subtext"><Skeleton /></p>
                    </div>
                    <div className="teaser-accommodation--worlds">
                        <Skeleton count={3} borderRadius={100}/>
                    </div>*/}
                    <div className="teaser-accommodation--booking">
                        <Skeleton height={50} />
                    </div>
                </div>
            </div>
        </article>
    )
};

export default AccommodationTeaserSkeleton;
